/* @flow */
import * as menuDebtsActions from './actions';
import * as paymentPopupActions from '../../../paymentPopup/actions';
import {fromJS, Record, List, Map} from 'immutable';

const State = Record({
    page: 0,
    limit: 8,
    max: 0,
    habitue: null,
    bills: List(),
    id: null,
    detailDebtItemsId: null,
    oneDebtToPay: null,
    debtsToPay: null,
    selectedBills: Map()
});

const SELECTED_BILLS = 'selectedBills';
const PAGE = 'page';
const MAX = 'max';
const BILLS = 'bills';
const HABITUE = 'habitue';
const ID = 'id';
const DETAIL_DEBT_ITEMS_ID = 'detailDebtItemsId';
const ONE_DEBT_TO_PAY = 'oneDebtToPay';
const DEBTS_TO_PAY = 'debtsToPay';

const menuDebtDetailReducer = (state = new State(), action) => {

    switch (action.type) {

        case menuDebtsActions.TOGGLE_BILL_CHECKBOX: {
            const {id, price} = action.payload;
            if (state.get(SELECTED_BILLS).has(id)) {
                return state.update(SELECTED_BILLS, bills => bills.delete(id));
            } else {
                return state.update(SELECTED_BILLS, bills => bills.set(id, price));
            }
        }

        case menuDebtsActions.CLEAR_BILL_CHECKBOX: {
            return state.set(SELECTED_BILLS, Map());
        }

        case menuDebtsActions.FETCH_HABITUE_BIlLS_TO_PAY_SUCCESS: {
            const data = action.payload.data;
            return state.set(DEBTS_TO_PAY, fromJS(data));
        }

        case menuDebtsActions.FETCH_HABITUE_BIlLS_TO_PAY_ERROR:
        case paymentPopupActions.CLOSE_PAYMENT_POPUP: {
            return state
                .set(ONE_DEBT_TO_PAY, null)
                .set(DEBTS_TO_PAY, null);
        }

        case menuDebtsActions.COOSE_DEBT_TO_PAY: {
            const {id} = action.payload;
            return state.set(ONE_DEBT_TO_PAY, id);
        }

        case menuDebtsActions.FETCH_HABITUE_DETAIL_ERROR:
        case menuDebtsActions.CLEAR_HABITUE_DETAIL: {
            return state
                .set(BILLS, null)
                .set(ID, null)
                .set(PAGE, 0)
                .set(BILLS, List())
                .set(MAX, 0);
        }

        case menuDebtsActions.FETCH_HABITUE_DETAIL_SUCCESS: {
            const {page, habitue, bills, max} = action.payload.data;
            return state
                .set(PAGE, page)
                .set(HABITUE, fromJS(habitue))
                .set(BILLS, fromJS(bills))
                .set(MAX, max);
        }

        case menuDebtsActions.CHOOSE_HABITUE_DETAIL: {
            const {id} = action.payload;
            return state.set(ID, id);
        }

        case menuDebtsActions.SHOW_DETAIL_DEBT_ITEMS: {
            const {id} = action.payload;
            return state.set(DETAIL_DEBT_ITEMS_ID, id);
        }

    }

    return state;
};

export default menuDebtDetailReducer;



// WEBPACK FOOTER //
// ./src/common/menu/credit/debtDetail/reducer.js